var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeasonRegularMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.8469C14.6658 0.596468 17.3342 0.596468 19.5 1.8469L28.0885 6.80544C30.2543 8.05587 31.5885 10.3668 31.5885 12.8676V22.7847C31.5885 25.2856 30.2543 27.5965 28.0885 28.8469L19.5 33.8054C17.3342 35.0559 14.6658 35.0559 12.5 33.8054L3.91154 28.8469C1.74574 27.5965 0.411543 25.2856 0.411543 22.7847V12.8676C0.411543 10.3668 1.74574 8.05588 3.91154 6.80545L12.5 1.8469Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.8469C14.6658 0.596468 17.3342 0.596468 19.5 1.8469L28.0885 6.80544C30.2543 8.05587 31.5885 10.3668 31.5885 12.8676V22.7847C31.5885 25.2856 30.2543 27.5965 28.0885 28.8469L19.5 33.8054C17.3342 35.0559 14.6658 35.0559 12.5 33.8054L3.91154 28.8469C1.74574 27.5965 0.411543 25.2856 0.411543 22.7847V12.8676C0.411543 10.3668 1.74574 8.05588 3.91154 6.80545L12.5 1.8469Z",
    fill: "url(#paint0_radial_20471_5388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.71292C14.8564 1.64113 17.1436 1.64113 19 2.71292L27.5885 7.67147C29.4449 8.74327 30.5885 10.724 30.5885 12.8676V22.7847C30.5885 24.9283 29.4449 26.9091 27.5885 27.9809L19 32.9394C17.1436 34.0112 14.8564 34.0112 13 32.9394L4.41154 27.9809C2.55514 26.9091 1.41154 24.9283 1.41154 22.7847V12.8676C1.41154 10.724 2.55514 8.74327 4.41154 7.67147L13 2.71292Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20471_5388",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 13.3262) rotate(82.4054) scale(22.6991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonRegularMedal);
export default __webpack_public_path__ + "static/media/season-regular-medal.ef1c15dc2406a2e074c733b8829da88f.svg";
export { ForwardRef as ReactComponent };